/**
 * BENCHMARK.TYPES
 * List of type for the benchmark
 */

export interface BenchmarkItem {
  id: string
  type: string
  value: number
  sector: string
  question?: string | null
  topic?: string | null
}

export const BENCHMARK_SECTOR_LIST = [
  "tech",
  "commerce",
  "industry",
  "healthcare",
  "education",
  "services",
  "media",
  "public",
  "associations",
  "housing",
  "other"
]
